/**
 * @module constants
 */

export default {
  NewFolder: -1,
  GlobalNeverExpiring: -2,
  GlobalWeek: -3,
  GlobalDay: -4,
  UserNeverExpiring: -5,
  UserWeek: -6,
  UserDay: -7
};



// WEBPACK FOOTER //
// ./app/constants/specialSavedItemFolderIds.js